import React from "react";

const Loader = () => {
  return (
    <div className="mx-auto h-3 w-3 animate-spin rounded-full border-2 border-solid border-white border-t-transparent"></div>
  );
};

export default Loader;
